import { oneLine } from 'common-tags';
import { ErrorMessage, Field } from 'formik';

import type { FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { CheckboxProps } from './types';

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  children,
  disabled = false,
  name,
  className = '',
  value,
}: CheckboxProps) => (
  <Field name={name}>
    {({ field, meta: { error, touched } }: FieldProps) => (
      <>
        <label
          htmlFor={`${name}-${value}`}
          className={oneLine`
            text-link--m text-link inline-flex cursor-pointer select-none text-neutrals-500 checked:text-neutrals-900
            ${disabled ? 'opacity-40' : ''}
            ${error && touched ? 'text-status-error' : ''}
            ${className}
          `}
        >
          <input
            type="checkbox"
            id={`${name}-${value}`}
            disabled={disabled}
            className="mr-3 h-5 w-5 cursor-pointer rounded border-neutrals-500 checked:text-primary-500 checked:ring-0 focus:ring-0 focus:ring-offset-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
            checked={field.value}
            {...field}
          />

          {children}
        </label>

        <ErrorMessage name={name}>
          {(msg) => (
            <div className="text-body text-body--s text-status-error">
              {msg}
            </div>
          )}
        </ErrorMessage>
      </>
    )}
  </Field>
);

Checkbox.displayName = 'Checkbox';
